import type { IStorage } from "@/core/plugins/storage/Storage";
import { IUserRolesResponse } from "./types";
import { LocalStorageKeys } from "@/core/@types/types";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

@injectable()
export class UserRoles {
  @inject(DITypes.STORAGE)
  private storage!: IStorage;

  response: IUserRolesResponse | undefined;

  handleUserRoles() {
    const storageRoles = this.response || [];

    this.storage.set(LocalStorageKeys.userRules, storageRoles.join(","));

    return true;
  }
}
